module.exports = __webpack_public_path__ + "static/media/nater5bw.3505d5b5.png";